import { useTitle } from "@/hooks/use-title.hook.ts";
import { CustomFieldList } from "@/pages/settings/custom-fields/components/CustomFieldList.tsx";
import { useTabsByEntityType } from "@/queries/use-custom-fields.query.ts";
import { ApiCFEntityTypes, ApiCFTabType } from "@/types/custom-field.types.ts";
import { Page, Skeleton, Stack, Title } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

const titleKeys: Partial<Record<ApiCFEntityTypes, string>> = {
  [ApiCFEntityTypes.applicant]: "custom_fields:applicant_fields",
  [ApiCFEntityTypes.job]: "custom_fields:job_fields",
  [ApiCFEntityTypes.offer]: "custom_fields:offer_fields",
};

export function RecruitingCustomFieldsIndex({ entityType }: { entityType: ApiCFEntityTypes }) {
  const { t } = useTranslation();
  const title = t(titleKeys[entityType] ?? "custom_fields:recruiting_settings_title");
  useTitle(title, t("common:settings"));
  const { data: tabs, isPending } = useTabsByEntityType(entityType);
  const tab = tabs?.find((tab) => tab.type === ApiCFTabType.overview);
  return (
    <Page>
      <Page.Header title={title} showBack />
      <Page.Content>
        <Stack className="px-16">
          <Title
            header={t("custom_fields:fields")}
            caption={t("custom_fields:recruiting_fields_how_works")}
            paddingTop
            paddingBottom
            size="lg"
          />
          {isPending && <Skeleton className="h-24 w-full" />}
          {tab && (
            <CustomFieldList
              key={`${entityType}-${tab.id}`}
              tabId={tab.id}
              entityType={entityType}
            />
          )}
        </Stack>
      </Page.Content>
    </Page>
  );
}
